import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import ChestDetail from "@/pages/ChestDetail";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import Billing from "@/pages/Billing";
import HopePlanner from "@/pages/HopePlanner";
import Settings from "@/pages/Settings";
import MagicLink from "@/pages/MagicLink";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Support from "@/pages/Support";
import Review from "@/pages/Review";
import Changelog from "@/pages/Changelog";
import Unsubscribe from "@/pages/Unsubscribe";
import Resources from "@/pages/Resources";
import AdminLayout from "@/pages/AdminLayout";
import CareMode from "@/pages/CareMode";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth/magic" element={<MagicLink />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/support" element={<Support />} />
      <Route path="/review" element={<Review />} />
      <Route path="/changelog" element={<Changelog />} />
      <Route path="/unsubscribe" element={<Unsubscribe />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/contact" element={<Navigate to="/support" replace />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/chest/:chestId" element={<ProtectedRoute><ChestDetail /></ProtectedRoute>} />
      <Route path="/chest" element={<Navigate to="/dashboard" replace />} />
      <Route path="/planner/:chestId" element={<ProtectedRoute><HopePlanner /></ProtectedRoute>} />
      <Route path="/planner" element={<Navigate to="/dashboard" replace />} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>} />
      <Route path="/admin/checklist" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>} />
      <Route path="/care-mode/:chestId" element={<ProtectedRoute><CareMode /></ProtectedRoute>} />
      <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
